module.exports = __webpack_public_path__ + "img/cbfx.920f0f18.png";